export enum Permission {
    CAN_MANAGE_ENGINEERING_FILES = "CanAddUpdateFiles"
}